const v9 = (state: any) => {
  return {
    ...state,
    options: {
      ...state.options,
      tableViews: {
        ...state.options.tableViews,
        distributionVideoSummaryTable: {
          "Project ID": true,
          Thumbnail: true,
          "Video Title": true,
          "Production ID": true,
          "Network & Channel": true,
          "Compilation Type": true,
          "Scheduled Date": true,
          "Release Date": true,
          "Total Views": true,
        },
        distributionProjectSummaryTable: {
          "Project ID": true,
          Thumbnail: true,
          "Video Title": true,
          "Production ID": true,
          "Last Release Date": true,
          Releases: true,
          "Last Release Views": true,
          "Best Release Views": true,
          "Title Topics": true,
          "Video Types": true,
        },
      },
    },
  };
};

export default v9;
